import { BaseService } from './BaseService';

// https://github.com/microsoft/TypeScript/issues/1778

export type SANSProductId = string;
export type Price = string;
export type Dataset = 'courses' | 'certifications';
export type LookupType = 'id' | 'sfId' | 'productCode';

interface Pricing {
  readonly pricing: Price;
  readonly pricing_early_bird: Price;
  readonly pricing_early_bird_2: Price;
}

export interface PricingMap {
  // TODO figure out why I still have to do this
  [key: string]: Pricing;
  //[key: SANSProductId]: Pricing;

}
export interface EventPricingLineItemAddOn {
  readonly certificationPrice?: number;
  readonly onDemandPrice?: number;
}
export interface EventPricingLineItem {
  readonly sansProductId: string;
  readonly listPrice: string;
  readonly pricebookEntryId: string;
  readonly productId: string;
  readonly success: boolean;
  readonly unitPrice: string;
  readonly currencyIsoCode: string;
  readonly addons?: EventPricingLineItemAddOn;
  readonly type?: string;
  readonly productCode?: string;
  readonly gated?: boolean;
}

export interface ProductPricingServiceResponse {
  readonly success: boolean;
  readonly pricingLineItemResults: EventPricingLineItem[];
}

export interface BatchGetProductsResponse {
  readonly pricing: Record<string, EventPricingLineItem>;
}

export class ProductService extends BaseService {

  constructor() {
    super({ configPath: 'services.products' });
  }

  async pricing(dataset: Dataset, refresh: boolean = false): Promise<ProductPricingServiceResponse> {
    return this.requestResource('products', {
      tokenType: 'none',
      query: { dataset, refresh },
    });
  }

  async iamPricing(dataset: Dataset, refresh: boolean = false): Promise<ProductPricingServiceResponse> {
    return this.requestResource('service.products', {
      sign: true,
      tokenType: 'none',
      query: { dataset, refresh },
    });
  }

  async findProduct(productId: string, dataset: Dataset, lookupType: LookupType): Promise<EventPricingLineItem> {
    return this.requestResource('service.product', {
      tokenType: 'none',
      sign: true,
      params: { productId },
      query: { dataset, lookupType },
    });
  }

  async findProductBySalesforceId(productId: string, dataset: Dataset) {
    return this.findProduct(productId, dataset, 'sfId');
  }

  async findProductByProductCode(productCode: string, dataset: Dataset) {
    return this.findProduct(productCode, dataset, 'productCode');
  }

  async findProductById(productId: string, dataset: Dataset) {
    return this.findProduct(productId, dataset, 'id');
  }

  async getBatch(productIds: string[]): Promise<BatchGetProductsResponse> {
    return this.requestResource('service.batchGet', {
      tokenType: 'none',
      sign: true,
      query: { productIds: productIds.join(',') },
    });
  }
}

export default ProductService;
